import { Grid } from "@mui/material";
import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowCheckpointStore } from "../../../../../store";
import { OnlyPhoto } from "../../../shared-component";
import { Image } from "antd";
import noImg from "../../../../../assets/images/not-found.jpg";

export const SelloNaviera = ({ widthFull }: { widthFull: string }) => {

  const botellaNavieraPhoto = useWorkflowCheckpointStore(
    (state) => state.botellaNavieraPhoto
  );
  const botellaNavieraCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.botellaNavieraCheckPhoto
  );
  const setBotellaNavieraPhoto = useWorkflowCheckpointStore(
    (state) => state.setBotellaNavieraPhoto
  );

  const {
    open: openSelloNaviera,
    handleClose: handleCloseSelloNaviera,
    handleOpen: handleOpenSelloNaviera,
  } = useOpen();
  const fotoUrl = useBlobUrl(botellaNavieraPhoto);

  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white" }}
    >
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <OnlyPhoto
            foto={fotoUrl}
            label="SELLO BOTELLA"
            handleClose={handleCloseSelloNaviera}
            handleOpen={handleOpenSelloNaviera}
            open={openSelloNaviera}
            setFoto={setBotellaNavieraPhoto}
            width={widthFull === "xs" ? 150 : 220}
          />
        </div>
        <Image
          src={
            botellaNavieraCheckPhoto === "" ? noImg : botellaNavieraCheckPhoto
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
    </Grid>
  );
};
